import React, { PureComponent } from 'react'
import classNames from 'classnames'
import { withTranslation } from 'react-i18next'

import Fire from 'app/components/SVGS/Fire'
import './styles.scss'

const bc = 'fire-streak-label'

class FireStreakLabel extends PureComponent {
  static defaultProps = {
    radiusCircle: 80,
    fireHeight: 40,
  }
  render() {
    let { t, streakCurrent, streakMax } = this.props
    const { radiusCircle, fireHeight } = this.props
    const noStreak = streakCurrent === 0 && streakMax === 0
    return (
      <div className={`${bc}__wrapper`}>
        <div
          className={classNames(`${bc}__fire`, {
            [`${bc}__fire--no-streak`]: noStreak,
            [`${bc}__fire--animation`]: !noStreak,
          })}
          style={{
            width: radiusCircle,
            height: radiusCircle,
          }}
        >
          <Fire noStreak={noStreak} svgProps={{ height: fireHeight }} />
        </div>
        <div className={`${bc}__stats`}>
          <span className={classNames(`${bc}__stats--current`, { [`${bc}__stats--no-streak`]: noStreak })}>
            {streakCurrent || streakMax}
          </span>
          <div className={`${bc}__stats--title`}>
            {t('Streak')}
            <br />&nbsp;
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation('user')(FireStreakLabel)
